<template>
  <div class="carmi_wrap">
    <div class="container">
      <div class="header">
        请输入卡密
      </div>
      <div class="carmi_input">
        <input type="text" v-model="value">
      </div>
      <div class="confirm_btn">
        <span @click="close">取消</span>
        <span @click="confirm">确认</span>
      </div>
      <!-- <img class="icon_close" src="https://images.zhibo.tv/2021/0509/icon_cancel@3x.png" @click="close" alt=""> -->
    </div>
  </div>
</template>
<script>

export default {
  props: ['code'],
  data() {
    return {
      value: ''
    }
  },
  created() {
  },
  methods: {
    // 确定
    async confirm() {
      if (!this.value.length) {
        this.$emit('changeToast', '请输入卡密')
      } else {
        this.$emit('changeShow', 'confirm', this.value)
      } 
    },
    // 关闭
    close() {
      this.$emit('changeShow', 'carmi')
    }
  }
}
</script>
<style lang="less" scoped>
.carmi_wrap {
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.6);
  position: fixed;
  top: 0;
  .container {
    width: 5.2rem;
    height: 3.17rem;
    position: absolute;
    bottom: 0;
    background: #ffffff;
    padding-top: .4rem;
    box-sizing: border-box;
    border-radius: .2rem;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}
.header {
  height: .48rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: .32rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #222222;
}
.carmi_input {
  margin-top: .3rem;
  padding: 0 .3rem;
  box-sizing: border-box;
  height: .8rem;
  width: 100%;
  display: flex;
  input {
    height: 100%;
    background: #F7F7F7;
    border-radius: .14rem;
    border: none;
    width: 100%;
    padding: 0 .24rem;
    box-sizing: border-box;
    letter-spacing: 1px;
    font-size: .28rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
  }
}
.confirm_btn {
  height: .88rem;
  width: 100%;
  font-size: .34rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  text-align: center;
  display: flex;
  margin-top: .3rem;
  border-top: 1px solid #EAEAEA;
  >span {
    width: 50%;
    line-height: .88rem;
    text-align: center;
    &:last-child {
    color: #FF4A4A;
    border-left: 1px solid #EAEAEA;
  }
  }
}
</style>
